const state = {
  stockScreens: {},
  meanReversion: {},
  compsheetmidcap: {},
  peelhuntSectors: {},
  peelhunttable: {},
};

const actions = {};

const getters = {
  stockScreens: (state) => state.stockScreens,
  meanReversion: (state) => state.meanReversion,
  compsheetmidcap: (state) => state.compsheetmidcap,
  peelhuntSectors: (state) => state.peelhuntSectors,
  peelhunttable: (state) => state.peelhunttable,
};

const mutations = {
  SET_STOCK_SCREENS: (state, stockScreens) => {
    state.stockScreens = stockScreens;
  },
  SET_MEANREVERSION: (state, meanReversion) => {
    state.meanReversion = meanReversion;
  },
  SET_COMPSHEETMIDCAP: (state, compsheetmidcap) => {
    let formattedData = compsheetmidcap.map(function(d) {
      return {
        Company:	d.company,
        DIV_yield:	d.div_yield,
        EV_EBITDA_first_year: 	d.ev_ebitda_first_year ,
        EV_EBITDA_second_year:	d.ev_ebitda_second_year,
        EV_assets:	d.ev_assets,
        EV_sales:	d.ev_sales,
        NTM:	d.ntm,
        PE_first_year:	d.pe_first_year,
        PE_second_year:	d.pe_second_year,
        P_B:	d.p_b,
        ROE:	d.roe,
        ROIC_first:	d.roic_first,
        ROIC_second:	d.roic_second,
        ROIC_third:	d.roic_third,
        Rating:	d.rating,
        Symbol:	d.symbol,
        TargetPrice:	d.targetprice,
        cons:	d.cons,
        ev_ebitda_as_por:	d.ev_ebitda_as_por,
        id:	d.id,
        net_debt_ebitda:	d.net_debt_ebitda,
        post_PCF_yield:	d.post_pcf_yield,
        pre_PCF_yield:	d.pre_pcf_yield,
        total_return:	d.total_return,

      }
    })
    sessionStorage.setItem("smallCapData", JSON.stringify(formattedData));
    state.compsheetmidcap = compsheetmidcap;
  },
  SET_COMPSHEETLARGECAP: (state, compsheetlargecap) => {
    let formattedData = compsheetlargecap.map(function(d) {
      return {
        "Above 50-day?":d.above,
        "Altman Z Score":d.aitman,
        "Company":d.company,
        "Days To Cover":d.daystocover,
        "EBITDA Margin":d.ebitdamargin,
        "EBITDA Margin vs 7 yrs Peak":d.ebitdamarginvs,
        "EPS % YOY First Year":d.epsfirstyear,
        "EPS % YOY Second Year":d.epsrevisionsbeg,
        "Eps First Year":d.epsrevisionsend,
        "Eps Revisions Beg":d.epssecondyear ,
        "Eps Revisions End":d.epsthirdyear,
        "Eps Second Year":d.epsyoyfirstyear,
        "Eps Third Year":d.epsyoysecondyear,
        "Mkt Cap ($mm)":d.mktcap,
        "Price":d.price,
        "Price Performance 1M":d.priceperformancebeg,
        "Price Performance Period":d.priceperformanceend,
        "Rating":d.rating,
        "Relative Strength":d.relativestrength,
        "Short Interest":d.shortinterest,
        "Symbol":d.symbol,
        "Target Price":d.targetprice,
        "Upside":d.upside,
        "id":d.id,
      }
    })
    sessionStorage.setItem("largeCapData", JSON.stringify(formattedData));
    state.compsheetlargecap = compsheetlargecap;
  },
  SET__SECTORS_PEELHUNT: (state, peelhuntSectors) => {
    // console.log('SET__SECTORS_PEELHUNT--------', peelhuntSectors);
    state.peelhuntSectors = peelhuntSectors;
  },
  SET_PEELHUNTTABLE: (state, peelhunttable) => {
    // console.log('SET_PEELHUNTTABLE--------', peelhunttable);
    state.peelhunttable = peelhunttable;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
